import React from 'react'
import { Table } from 'semantic-ui-react'
import FindingLayout from '../../../FindingLayout'

class ExpiringCerts extends React.Component {
  render() {
    const finding = this.props.data;
    const printStyle = this.props.printStyle || false;
    const certs = finding.vulnerableEntity.map(r => r.node).filter(n => (n.__typename === 'Certificate'))
    return (
      <FindingLayout
        type='Cryptography' 
        icon='key'
        cve={finding.idCve}
        cwe={finding.idCwe}
        title={finding.title}
        overallCvss={(printStyle === true) ? finding.scoreCvss : null}
        description={finding.description}
        impact={finding.impact}
        recommendation={finding.recommendation}     
        Details={() => (
          <div>
            <Table compact celled collapsing style={{tableLayout: 'fixed', width: '100%'}}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell style={{width: '4em'}}>Type</Table.HeaderCell>
                  <Table.HeaderCell>Certificate Subject</Table.HeaderCell>
                  <Table.HeaderCell style={{width: '12em'}}>Expiration Date</Table.HeaderCell>
                  <Table.HeaderCell>Location</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
              { certs.map((cert) => {
                return (
                  <Table.Row key={cert.id}>
                    <Table.Cell>{cert.type.toUpperCase()}</Table.Cell>
                    <Table.Cell>{cert.subject}</Table.Cell>
                    <Table.Cell>{cert.notAfter}</Table.Cell>
                    <Table.Cell style={{fontFamily: 'monospace', overflowWrap: 'break-word'}}>{cert.extractedFrom.node.path}</Table.Cell>
                  </Table.Row>
                )
              })}
              </Table.Body>
            </Table>
          </div>
        )}
      />
    )
  }
}

export default ExpiringCerts